
// @ts-nocheck


export const localeCodes =  [
  "de",
  "en"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_main_46js_92e2b568",
      load: () => import("#nuxt-i18n/92e2b568" /* webpackChunkName: "locale_main_46js_92e2b568" */),
      cache: false
    }
  ],
  en: [
    {
      key: "locale_main_46js_5bd0f018",
      load: () => import("#nuxt-i18n/5bd0f018" /* webpackChunkName: "locale_main_46js_5bd0f018" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/60e8ebf2" /* webpackChunkName: "config_i18n_46config_46ts_60e8ebf2" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      files: [
        {
          path: "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/i18n/locales/de/main.js",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      files: [
        {
          path: "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/i18n/locales/en/main.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    files: [
      {
        path: "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/i18n/locales/de/main.js",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    files: [
      {
        path: "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/i18n/locales/en/main.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/